import { combineReducers } from 'redux';
import notification from './notification';
import constant from './constant';
import task from './task';
import job from './job';
// eslint-disable-next-line import/no-cycle
import profile from './profile';
import billingAccount from './billingAccount';
import filter from './filter';
import account from './account';
import globalSearch from './globalSearch';
import customFieldGroup from './customFieldGroup';
import language from './language';
import ourLocation from './ourLocation';
import customLayout from './customLayout';
import versadriveSetting from './versadriveSetting';

const rootReducer = combineReducers({
  notification,
  constant,
  task,
  job,
  profile,
  billingAccount,
  filter,
  account,
  globalSearch,
  customFieldGroup,
  language,
  ourLocation,
  customLayout,
  versadriveSetting,
});

export default rootReducer;
